"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksLinkPostAsyncSlice = void 0;
const get_1 = require("../get.js");
const name_1 = require("./name.js");
const _api_1 = require("../../../../api/index.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesTasksLinkPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.INITIATIVE_SCOPE_LINKED_TO_TASK, (action) => {
                var _a, _b, _c;
                return ({
                    bulk: action.data.all,
                    scopeCount: (_b = (_a = action.data.sonarObjectIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : (_c = action.data.initiativeScopeIds) === null || _c === void 0 ? void 0 : _c.length
                });
            }),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            ({ initiativeId }) => get_1.coreInitiativesTasksGetAsyncSlice.asyncActionCreators.requestGetCoreInitiativesTasks({ initiativeId })
        ]
    },
    name: name_1.CoreInitiativesTasksLinkName,
    receive: false,
    request: true,
    requestHandler: _api_1.postInitiativeTaskLink
});
//# sourceMappingURL=post.js.map